import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowLeft, ArrowRight, Check, LogIn } from 'lucide-react';
import ApplicationProgress from './ApplicationProgress';
import './ApplicationConfirmation.css';

const ApplicationConfirmation = ({ application, onBackToCareers }) => {
  const [secondsRemaining, setSecondsRemaining] = useState(5);
  const titleRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const deadline = performance.now() + 5000;
    const timer = window.setInterval(() => {
      const remaining = Math.max(0, Math.ceil((deadline - performance.now()) / 1000));
      setSecondsRemaining(remaining);
      if (remaining === 0) window.clearInterval(timer);
    }, 100);
    titleRef.current?.focus({ preventScroll: true });
    window.scrollTo(0, 0);
    return () => window.clearInterval(timer);
  }, []);

  return (
    <>
      <section className="application-confirmation" aria-labelledby="application-confirmation-title">
        <p className="application-confirmation-breadcrumb">Careers / Application complete</p>
        <div className="application-confirmation-summary">
          <span className="application-confirmation-check" aria-hidden="true"><Check size={34} strokeWidth={2} /></span>
          <h1 id="application-confirmation-title" ref={titleRef} tabIndex={-1}>Application submitted.</h1>
          <p className="application-confirmation-intro">Thank you for your interest in Veloura.<br />We&apos;ve received your application and will review it shortly.</p>
          <p className="application-confirmation-badge"><span aria-hidden="true" />Successfully received</p>
          <div className="application-confirmation-actions">
            <button
              type="button"
              className="application-confirmation-primary"
              disabled={secondsRemaining > 0}
              onClick={() => navigate(`/application/${application.application_token}`)}
            >
              <span>View application status{secondsRemaining > 0 ? ` (${secondsRemaining}s)` : ''}</span><ArrowRight size={23} aria-hidden="true" />
            </button>
            <a href="https://gtaw.link/veloura" className="application-confirmation-secondary"><LogIn size={25} aria-hidden="true" />Go to Portal</a>
          </div>
        </div>
        <ApplicationProgress status={application.status} />
      </section>
      <Link to="/careers" className="application-confirmation-back" onClick={onBackToCareers}><ArrowLeft size={22} aria-hidden="true" />Back to careers</Link>
    </>
  );
};

export default ApplicationConfirmation;
